package pl.mothdigital.neuronowi

import com.varabyte.kobweb.core.init.InitKobweb
import com.varabyte.kobweb.core.init.InitKobwebContext
import pl.mothdigital.neuronowi.components.error.NotFoundPage

@InitKobweb
fun initKobweb(ctx: InitKobwebContext) {
    ctx.router.setErrorPage { _ ->
        NotFoundPage()
    }
}
